var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signin"}},[_c('div',{attrs:{"id":"form"}},[(_vm.showAuthChoices)?_c('LoginForm',{attrs:{"choices":_vm.authMethods},on:{"choose":_vm.redirectAuth}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }